import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDeployedCodeUpdate = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M18 22L21 19L20.3 18.3L18.5 20.1V16H17.5V20.1L15.7 18.3L15 19L18 22ZM12 10.85L6.075 7.425L5 8.05V9.1L12 13.15L19 9.1V8.05L17.925 7.425L12 10.85ZM11 21.725L4 17.7C3.68333 17.5167 3.4375 17.275 3.2625 16.975C3.0875 16.675 3 16.3417 3 15.975V8.025C3 7.65833 3.0875 7.325 3.2625 7.025C3.4375 6.725 3.68333 6.48333 4 6.3L11 2.275C11.3167 2.09167 11.65 2 12 2C12.35 2 12.6833 2.09167 13 2.275L20 6.3C20.3167 6.48333 20.5625 6.725 20.7375 7.025C20.9125 7.325 21 7.65833 21 8.025V12.675C20.55 12.4583 20.0708 12.2917 19.5625 12.175C19.0542 12.0583 18.5333 12 18 12C16.0667 12 14.4167 12.6833 13.05 14.05C11.6833 15.4167 11 17.0667 11 19C11 19.5333 11.0542 20.0458 11.1625 20.5375C11.2708 21.0292 11.4333 21.5 11.65 21.95C11.5333 21.9167 11.4208 21.8875 11.3125 21.8625C11.2042 21.8375 11.1 21.7917 11 21.725ZM18 24C16.6167 24 15.4375 23.5125 14.4625 22.5375C13.4875 21.5625 13 20.3833 13 19C13 17.6167 13.4875 16.4375 14.4625 15.4625C15.4375 14.4875 16.6167 14 18 14C19.3833 14 20.5625 14.4875 21.5375 15.4625C22.5125 16.4375 23 17.6167 23 19C23 20.3833 22.5125 21.5625 21.5375 22.5375C20.5625 23.5125 19.3833 24 18 24Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgDeployedCodeUpdate);
export default ForwardRef;
